import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import isNil from "lodash/isNil";
import { Typography } from "@mui/material";
import "../styles/Footer.css";
import { isMobile } from "react-device-detect";
import PropTypes from "prop-types";
function MenuFooter(props) {
  const { footerLinks } = props;
  // esto se pasa al padre y se pasa luego por props

  return (
    <footer className="site-footer">
      <Typography
        style={{ fontSize: !isMobile ? "1.6rem" : "1.2rem" }}
        variant="h6"
      >
        {" "}
        Mapa del sitio{" "}
      </Typography>
      <div className="footer-sitemap">
        {!isNil(footerLinks) && (
          <nav aria-label="Mapa del sitio">
            <ul>
              {footerLinks.map(
                (item) =>
                  
                    <li key={item.path}>
                      <Link
                        to={item.path}
                        style={{
                          fontWeight: 700,
                          fontSize: isMobile ? "1rem" : "1.2rem",
                        }}
                        className="footer-link"
                      >
                        {item.title}
                      </Link>                     
                    </li>
                  
              )}
            </ul>
          </nav>
        )}
      </div>
    </footer>
  );
}
MenuFooter.propTypes = {
  footerLinks: PropTypes.shape({}),
};

export default MenuFooter;
